import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import AvatarMui from '@material-ui/core/Avatar'
import { makeStyles } from '@material-ui/core/styles'

import Styles from './Avatar.module.css'

const useSizes = makeStyles((theme) => ({
  small: {
    width: theme.spacing(3),
    height: theme.spacing(3),
  },
  medium: {
    width: '38px',
    height: '38px',
  },
  large: {
    width: theme.spacing(5),
    height: theme.spacing(5),
  },
}))

const useStyles = makeStyles(() => ({
  root: {
    display: 'inline-flex',
    verticalAlign: 'middle',
  },
}))

const Avatar = ({ size, testId, ...props }) => {
  const classes = useStyles()
  const sizeClass = useSizes()[size] || null

  return (
    <AvatarMui
      {...props}
      className={classNames(Styles.avatarImg, sizeClass)}
      data-testid={testId}
      classes={classes}
      sizes="small"
    />
  )
}

Avatar.propTypes = {
  size: PropTypes.string,
  testId: PropTypes.string,
}

export default Avatar
